
import Base from '@/pages/index.vue';
import { mapGetters } from 'vuex';
import { setRocketHttpAssets } from '@/libs/http-assets.js';
import { getIsInTapTap } from '@/libs/device.js';
import TAPTAP from '@/libs/client.js';
import { tapToast, removeToast } from '@/components/ui/TapToast/index.js';

const TAP_INIT_LIB_JS_SRC =
  'https://assets.tapimg.com/cupid-apps/site-builder-tap-components/static/commonjs_v5.umd.js';

export default {
  components: {
    Base,
  },
  // extends: Base,
  data() {
    return {};
  },
  head() {
    return {
      meta: [
        {
          name: 'viewport',
          content:
            'width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no,viewport-fit=cover',
        },
        // { 后期可以改成按需配置
        //   name: 'theme-color',
        //   content: '#009BAA',
        // },
        // {
        //   name: 'msapplication-TileColor',
        //   content: '#009BAA',
        // },
      ],
      script: [
        {
          src: TAP_INIT_LIB_JS_SRC,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['$bus']),
  },
  created() {
    if (!process.server) {
      if (window.$tapComponentsInit && window.$tapComponentsInit.request) {
        setRocketHttpAssets('taptap', window.$tapComponentsInit.request);
      }
      if (window.$tapComponentsInit && window.$tapComponentsInit.getUrl) {
        window.moo.getUrl = window.$tapComponentsInit.getUrl;
      }
      if (window.$tapComponentsInit && window.$tapComponentsInit.getUri) {
        window.moo.getUri = window.$tapComponentsInit.getUri;
      }
      const isInTapTap = getIsInTapTap();
      if (isInTapTap) {
        window.moo.ua.text += ' taptap';
      }
    }
  },
  beforeMount() {
    window.moo.TAPTAP = { ...TAPTAP };
    window.moo.TAPTAP.initWebviewEmit();
    this.$bus.$on('rocket:client:TapTapOpenBrowser', (param) => {
      window.moo.TAPTAP.clientApi('openBrowser', param);
    });
    this.$bus.$on('rocket:client:TapTapShowToast', (param) => {
      if (
        window.moo.CONSTANT.IS_IN_TAPTAP &&
        window.moo.TAPTAP.hasTapClientApi('showToast')
      ) {
        window.moo.TAPTAP.clientApi('showToast', param);
      } else {
        tapToast(param);
      }
    });
    this.$bus.$on('rocket:client:TapTapShowNavbar', () => {
      window.moo.TAPTAP.clientApi('toggleNavbar', 'show');
    });
    this.$bus.$on('rocket:client:TapTapHideNavbar', () => {
      window.moo.TAPTAP.clientApi('toggleNavbar', 'hide');
    });
    this.$bus.$on('rocket:client:TapTapShowShareBtn', () => {
      window.moo.TAPTAP.clientApi('toggleShareBtn', 'show');
    });
    this.$bus.$on('rocket:client:TapTapHideShareBtn', () => {
      window.moo.TAPTAP.clientApi('toggleShareBtn', 'hide');
    });
    this.$bus.$on('rocket:client:TapTapCloseWebView', () => {
      window.moo.TAPTAP.clientApi('closeWebView', '');
    });
    this.$bus.$on('rocket:client:TapTapOpenShareWindow', (...args) => {
      let params = window.moo.TAPTAP.getShareParams(...args);
      window.moo.TAPTAP.clientApi('openShareWindow', params);
    });
    this.$bus.$on('rocket:client:TapTapOpenImgShareWindow', (...args) => {
      let params = window.moo.TAPTAP.getImgShareParams(...args);
      window.moo.TAPTAP.clientApi('openImgShareWindow', params);
    });
    this.$bus.$on(
      'rocket:client:openTapTapMomentEditor',
      window.moo.TAPTAP.openTapTapMomentEditor
    );
    this.$bus.$on(
      'rocket:client:saveImageToAlbum',
      window.moo.TAPTAP.saveImageToAlbum
    );
  },
  beforeDestroy() {
    removeToast();
    this.$bus.$off('rocket:client:TapTapOpenBrowser');
    this.$bus.$off('rocket:client:TapTapShowToast');
    this.$bus.$off('rocket:client:TapTapShowNavbar');
    this.$bus.$off('rocket:client:TapTapHideNavbar');
    this.$bus.$off('rocket:client:TapTapShowShareBtn');
    this.$bus.$off('rocket:client:TapTapHideShareBtn');
    this.$bus.$off('rocket:client:TapTapCloseWebView');
    this.$bus.$off('rocket:client:TapTapOpenShareWindow');
    this.$bus.$off('rocket:client:TapTapOpenImgShareWindow');
    this.$bus.$off('rocket:client:openTapTapMomentEditor');
    this.$bus.$off('rocket:client:saveImageToAlbum');
    window.moo.TAPTAP.removeWebviewEmit();
  },
  methods: {},
};
